module.exports = __webpack_public_path__ + "NC.png?8482a61ff0529ab7ab7c99ae4cdecaca";